import { render } from "./Logs.vue?vue&type=template&id=438cfc97&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import "./Logs.vue?vue&type=style&index=0&id=438cfc97&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-438cfc97"

export default script